<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>每日收益分析</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-form :inline="true" class="user-search" :model="formInline" size="small">
			<el-form-item label="银行">
				<el-select v-model="formInline.city" placeholder="选择银行" clearable>
					<el-option :label="item" :value="item" v-for="(item,key) in manageCityList"
						:key="key">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="日期">
					<el-date-picker v-model="formInline.analysisDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
				<el-button size="small" type="primary" icon="el-icon-search" @click="updateDayYield" v-if="jurisdiction.includes(329)" >更新数据</el-button>
				<el-button size="small" type="warning" @click="exportData">导出</el-button>
				<!-- <el-button size="small" type="warning" @click="drawImg">画图</el-button> -->
			</el-form-item>
		</el-form>

		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;" >
			<el-table-column sortable prop="city" label="银行" width="100" align="center"></el-table-column>
			<el-table-column prop="bondDate" label="日期" align="center"></el-table-column>
			<el-table-column prop="holdVolume" label="持仓量" align="center"></el-table-column>
			<el-table-column prop="netValue" label="净值" align="center"></el-table-column>

			<el-table-column prop="yield" label="收益率（%)" align="center"></el-table-column>
			<el-table-column prop="yieldNoNoHoldCapitalGains" label="收益率2（%)" align="center"></el-table-column>
			<el-table-column prop="yield3" label="收益率3（%)" align="center"></el-table-column>

			<el-table-column prop="totalIncome" label="总收入" align="center"></el-table-column>
			<el-table-column prop="totalIncomeNoHoldCapitalGains" label="总收入(除持仓资本利得)" align="center"></el-table-column>

			<el-table-column prop="priceDiff" label="价差" align="center"></el-table-column>
			<el-table-column prop="capitalGains" label="资本利得" align="center"></el-table-column>
			<el-table-column prop="capitalGainsTraded" label="资本利得[交易]" align="center"></el-table-column>
			<el-table-column prop="interestIncome" label="利息收入" align="center"></el-table-column>
			<el-table-column prop="interestPayed" label="票息兑付" align="center"></el-table-column>
			<el-table-column prop="buyBackAmount" label="回购收入" align="center"></el-table-column>

			



		</el-table>
		
		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>




		<div id="mainYield" style="width: 800px; height: 600px;"></div>
		<div id="mainNetValue" style="width: 800px; height: 600px;"></div>
	</div>
</template>

<script>
	// import echarts from "echarts";
	let echarts = require('echarts/lib/echarts')
	require('echarts/lib/chart/line')
	require('echarts/lib/component/tooltip')
	require('echarts/lib/component/title')
	require("echarts/lib/component/legend");
	require("echarts/lib/component/grid");
	require("echarts/lib/component/toolbox");


	import {
		getAllCity,
		getManageCity,
		getMyYieldList,
		dayYieldListExport,
		getMyYieldListAll,
		updateDayYield
	} from '../../api/basisMG.js'
	// import methodsMixin from '@/utils/methodsMixin'
	// 导出模块
	export default {
		// mixins: [methodsMixin],

		// 模块数据
		data() {
			
			//数据  
			return {
				jurisdiction:JSON.parse(sessionStorage.getItem('jurisdiction')),
				listData: [],
				dialogVisible: false,
				rules:{
                    bondCode :[{required: true, message: '请输入', trigger: 'blur'}],
                    sex :[{required: true, message: '请输入', trigger: 'blur'}]
                },
				editForm: {
					bondCode:""
				},
				charts:"",
				cityList:[],
				manageCityList:[],
				opinionData:[1,2,3,4,8],
				
				allListData:[],
				imgDates:[],
				imgYieldSeries:[],
				imgNetValueSeries:[],



				alldata: false,
				checkAll: false,
				isIndeterminate: true,
				checkedLimit: [],
				manageWarehouseShow: false,
				manageWarehouseIds: '',
				// 门店信息列表
				loading: false,
				Visible: false,
				time: [],
				checkboxGroup: [],
				type: 'showVip',
				fileList: [],

				dialogImageUrl: '',

				uids: '',
				tagIds: '',
				vipName: '',
				agentName: '',
				vipLevel: '',
				agentLevel: '',
				// 所属分类
				tableData: [],
				value: [],
				
				selectEditForm: {},
				usernames: ''
			}
		},


		watch: {},

		methods: {
			// 获得表格数据
			getdata() {
				let param = this.formInline
				getMyYieldList(param).then(res => {
					this.saveParams(this.$route.path,param)
					if (res.code == '200') {
						this.listData = res.data.content
						this.pageparm.total = res.data.totalElements
					}
				})
			},
			exportData() {
				let param = this.formInline
				dayYieldListExport(param)
			},
			updateDayYield(){
				let param = this.formInline
				updateDayYield(param).then(res => {
                    if (res.code == '200') {
                        this.$message({ 
                            type: 'success',
                            message:'设置成功'
                        })
                        this.getdata()
                        this.dialogVisible = false
                    }
                })
			},
			getAllCity() {
				getAllCity().then(res => {
					if (res.code == '200') {
						this.cityList = res.data
					}
				})
				getManageCity().then(res => {
					if (res.code == '200') {
						this.manageCityList = res.data
						console.log("this.cityList",this.cityList)
					}
				})
			},

			drawImg(){
				getMyYieldListAll().then(res => {
					if (res.code == '200') {
						this.allListData=res.data
						this.allListData.forEach(item => {
						if (this.imgDates.indexOf(item.bondDate)<0){
							this.imgDates.push(item.bondDate)
						}
						})
						this.imgDates.sort()
						console.log("this.imgDates",this.imgDates)
						this.cityList.forEach(item => {
							var city=item
							var imgYieldserie=[]
							var imgNetVlaueSerie=[]
							this.allListData.forEach(item => {
							if (item.city==city){
								imgYieldserie.push({
									date: item.bondDate,
									value: item.yield
								})
								imgNetVlaueSerie.push({
									date: item.bondDate,
									value: item.netValue
								})
							}
							})
							this.imgYieldSeries.push({name: city,type: "line",stack: "总量",data: imgYieldserie})
							this.imgNetValueSeries.push({name: city,type: "line",stack: "总量",data: imgNetVlaueSerie})
						})
						this.drawLine("mainYield",'收益率【%】',this.imgYieldSeries)
						this.drawLine("mainNetValue",'净值',this.imgNetValueSeries)
					}
				})
			},

			drawLine(id,title,sers) {
				this.charts = echarts.init(document.getElementById(id));
				this.charts.setOption({
					title: {text: title,left: 'center',top: 20,textStyle: {color: '#000',fontSize: 22}},
					tooltip: {trigger: "axis",},
					legend: {data:this.cityList},
					grid: {left: "6%",right: "4%",bottom: "6%",containLabel: false},
					toolbox: {feature: {saveAsImage: {},},},
					xAxis: {type: "category",boundaryGap: false,data: this.imgDates},
					yAxis: {type: "value"},
					series:sers 
				});
			}
			
		},


		// 创建前状态(里面是操作)
		beforeCreate() { },
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path)
			this.getAllCity()
			this.getdata()
			
			
		},
		// 挂载前状态(里面是操作)
		beforeMount() { },
		// 挂载结束状态(里面是操作)
		mounted() { },
		// 更新前状态(里面是操作)
		beforeUpdate() { },
		// 更新完成状态(里面是操作)
		updated() { },
		// 销毁前状态(里面是操作)
		beforeDestroy() { },
		// 销毁完成状态(里面是操作)
		destroyed() { }
	};
</script>

<style scoped>
	.el-form-item {
		width: 30%;
		box-sizing: border-box;
	}

	.just-start {
		display: flex;
		justify-content: flex-start;
	}

	.marginT20 {
		margin-top: 20px;
	}
</style>